module.exports = __webpack_public_path__ + "img/2022-04-02_11-58-52.ca0fc907.jpg";